import { signInWithEmailAndPassword, signOut } from '../../../auth/staffAuthApi';
import { auth } from '../../../auth/appAuth';
import { sendCustomVerificationEmail } from '../../../auth/api/emailVerificationApi';
import { getDeluxeEnvironment } from '../payment/deluxeEnvironment';
import { provisionAccount } from '../../../api/signup';
import { apiRequest } from '../../../api/client';

export const hasConfirmedFirstPayment = (subscription) =>
  Boolean(subscription?.id && subscription?.firstPayment?.transactionId);

export const provisionPaidAccount = async (setupData) => {
  const subscription = setupData.subscription;
  if (!hasConfirmedFirstPayment(subscription)) {
    throw new Error('Payment was not confirmed. No account was created.');
  }

  const businessInfo = setupData.businessInfo || {};
  const data = await apiRequest('/api/auth/paid-signup', {
    method: 'POST',
    body: {
      email: businessInfo.email,
      password: businessInfo.password,
      firstName: businessInfo.firstName,
      lastName: businessInfo.lastName,
      companyName: businessInfo.companyName,
      businessPhone: businessInfo.businessPhone,
      businessPhoneE164: businessInfo.businessPhoneE164,
      personalPhone: businessInfo.personalPhone,
      personalPhoneE164: businessInfo.personalPhoneE164,
      packageId: setupData.package,
      packageName: setupData.packageName,
      billingCycle: setupData.billingCycle,
      subscriptionId: subscription.id,
      firstPaymentTransactionId: subscription.firstPayment.transactionId,
      deluxeCustomerId: subscription.deluxeCustomerId || subscription.customerProfileId || null,
      deluxePaymentMethodId: subscription.deluxePaymentMethodId || subscription.customerPaymentProfileId || null,
      paymentMethodLast4:
        subscription.paymentMethodLast4
        || subscription.paymentProfile?.last4
        || null,
      deluxeEnvironment: getDeluxeEnvironment(),
      amount: subscription.amount || subscription.firstPayment?.amount || setupData.total || null,
      limits: setupData.packageDetails?.limits || null,
    },
  });

  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      businessInfo.email,
      businessInfo.password
    );
    const idToken = await userCredential.user.getIdToken();
    await sendCustomVerificationEmail(idToken);
    if (data?.companyId) {
      await provisionAccount({
        token: idToken,
        companyId: data.companyId,
        company: {
          id: data.companyId,
          name: businessInfo.companyName,
          ownerId: userCredential.user.uid,
          ownerFirstName: businessInfo.firstName,
          ownerLastName: businessInfo.lastName,
          email: businessInfo.email,
          businessPhone: businessInfo.businessPhoneE164 || businessInfo.businessPhone,
        },
        user: {
          email: businessInfo.email,
          firstName: businessInfo.firstName,
          lastName: businessInfo.lastName,
          companyId: data.companyId,
          companyName: businessInfo.companyName,
          role: 'owner',
          accountType: 'company',
          emailVerified: false,
          status: 'active',
        },
      });
    }
  } catch (verifyErr) {
    console.warn('Could not send verification email:', verifyErr);
  } finally {
    try {
      await signOut(auth);
    } catch (signOutError) {
      console.warn('Could not sign out after account creation:', signOutError);
    }
  }

  return data;
};
